import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import Brand from './Brand';
import SupportButton from './SupportButton';
import '../pages/Login.css';

const AuthLayout = ({ title, description, children }) => (
  <main className="auth-layout">
    <aside className="auth-story">
      <Brand />
      <div className="auth-story-copy">
        <p className="section-kicker">Amazon 采购协作</p>
        <h2>
          采购订单与明细，
          <br />
          在一个工作区核对。
        </h2>
        <p>
          订单导入、批量处理与明细核对，
          <br />
          继续处理今天的采购业务。
        </p>
        <ol>
          <li>导入订单</li>
          <li>审核与处理</li>
          <li>查询与核对</li>
        </ol>
      </div>
      <span className="auth-story-footer">大黄蜂 / AMZ 采购工作台</span>
    </aside>
    <section className="auth-main">
      <Link className="auth-back" to="/home">
        <ArrowLeftOutlined /> 返回产品首页
      </Link>
      <div className="auth-form-container">
        <h1>{title}</h1>
        <p className="auth-description">{description}</p>
        {children}
      </div>
      <div className="auth-footnote">账号或邀请码有疑问？ <SupportButton type="link" size="small" /></div>
    </section>
  </main>
);
export default AuthLayout;
